import {ShiftEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ShiftAction} from "./ShiftActionMenu";
import {useShiftMutation} from "../../../hooks/useShiftMutation";

export type UseShiftActionProps = {}

export type UseShiftActionResult = {
  onShiftActionClick: (shift: ShiftEntity, action: ShiftAction) => void;
}

export const useShiftAction = (props: UseShiftActionProps = {}): UseShiftActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteShift,
  } = useShiftMutation()

  const _onShiftActionClick = useCallback((shift: ShiftEntity, action: ShiftAction) => {
    if (action === "EDIT") {
      navigate(`/shifts/form`, {state: {id: shift.id, database: shift.database}})
    } else if (action === "DELETE") {
      deleteShift(shift.id, undefined)
    }
  }, [navigate, deleteShift])

  return {
    onShiftActionClick: _onShiftActionClick
  }
}
